import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { RootState } from "../../../../redux/app/store";
import FilterByButton from "../../../ui/FilterButton";
import { mapDataToLabelValue } from "../../../../helpers";
import {
  fetchCourierFeeSettings,
  resetSettingsState,
} from "../../../../redux/features/settingsSlice";

interface ViewCourierPricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ViewCourierPricingModal: React.FC<ViewCourierPricingModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { courierFee } = useAppSelector((state: RootState) => state.settings);
  const [courierId, setCourierId] = useState<string>("");
  const { couriers } = useAppSelector((state) => state.courier);
  const dispatch = useAppDispatch();

  const handleFilterSelect = (value: string) => {
    setCourierId(value);
  };

  useEffect(() => {
    dispatch(resetSettingsState());
    courierId && dispatch(fetchCourierFeeSettings(courierId));
  }, [courierId, dispatch]);

  console.log("Courier Fee Data:", courierFee);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Courier Pricing Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-600 text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="flex w-full my-4">
          <FilterByButton
            options={mapDataToLabelValue(couriers?.data?.items, "name", "id")}
            onSelect={handleFilterSelect}
            buttonLabel="Select courier"
            classNames="min-w-[200px]"
          />
        </div>

        <div className="space-y-2 text-sm text-gray-700">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <strong>Courier ID: </strong> {courierFee?.courierId}
            </div>
            <div>
              <strong>Base Fee: </strong> ₦ 
              {courierFee?.baseFee?.toLocaleString()}
            </div>
            <div>
              <strong>Per KM Charge: </strong> ₦ 
              {courierFee?.perKmCharge?.toLocaleString()}
            </div>
            <div>
              <strong>Weight Factor: </strong> {courierFee?.weightFactor}
            </div>
            <div>
              <strong>Insurance % :</strong> {courierFee?.insurancePercentage}%
            </div>
          </div>
        </div>

        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-full hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCourierPricingModal;
